import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      borderRadius: palette.borderRadius.default,
      padding: '10px',
      transition: 'transform 0.5s',
      '&:hover': {
        transform: 'scale(1.05)'
      },
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    iconStart: {
      flexDirection: 'row-reverse'
    },
    primaryGreen: {
      border: 'none',
      backgroundColor: palette.common.green
    },
    primaryBlue: {
      border: 'none',
      backgroundColor: palette.common.primaryBlue,
      color: palette.common.white
    },
    secondaryGreen: {
      borderColor: palette.common.green,
      backgroundColor: 'transparent',
      border: '2px solid'
    },
    secondaryBlue: {
      color: palette.common.primaryBlue,
      borderColor: palette.common.primaryBlue,
      backgroundColor: 'transparent',
      border: '2px solid'
    },
    danger: {
      color: palette.danger.red,
      borderColor: palette.danger.red,
      backgroundColor: 'transparent',
      border: '2px solid'
    },
    text: {
      border: 'none',
      backgroundColor: 'transparent',
      color: palette.text.secondary
    },
    textDanger: {
      border: 'none',
      backgroundColor: 'transparent',
      color: palette.danger.red
    },
    mobileTab: {
      border: 'none',
      backgroundColor: palette.background.underBox,
      color: palette.text.primary,
      fontSize: '1.2rem',
      fontWeight: 600
    },
    disabled: {
      color: palette.text.primary,
      backgroundColor: palette.text.secondary,
      borderColor: palette.text.secondary,
      cursor: 'default',
      '&:hover': {
        transform: 'none'
      }
    },
    quizStart: {
      backgroundColor: palette.danger.paleRed,
      color: palette.text.white,
      border: 'none'
    },
    loading: {
      padding: '0'
    },
    loader: {
      width: '44px',
      height: '44px',
      display: 'inline-block',
      margin: '0 5px',
      boxSizing: 'border-box',
      transform: 'scale(0.5)',
      '&::before': {
        boxSizing: 'border-box',
        content: '""',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        position: 'absolute',
        display: 'block',
        background: '#FFFFFF',
        top: '37px',
        left: '19px',
        transform: 'translate(-18px, -18px)',
        animation:
          '$dotRect 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite'
      }
    },
    triangleLoader: {
      width: '48px',
      '&::before': {
        left: '21px',
        transform: 'translate(-10px, -18px)',
        animation:
          '$dotTriangle 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite'
      }
    },
    svg: {
      display: 'block',
      width: '100%',
      height: '100%'
    },
    svgContent: {
      fill: 'none',
      stroke: '#2F3545',
      strokeWidth: '10px',
      strokeLinejoin: 'round',
      strokeLinecap: 'round'
    },
    circle: {
      strokeDasharray: '150 50 150 50',
      strokeDashoffset: '75',
      animation:
        '$pathCircle 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite'
    },
    rect: {
      strokeDasharray: '192 64 192 64',
      strokeDashoffset: '0',
      animation:
        '$pathRect 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite'
    },
    triangle: {
      strokeDasharray: '145 76 145 76',
      strokeDashoffset: '0',
      animation:
        '$pathTriangle 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite'
    },
    '@keyframes dotRect': {
      '25%': {
        transform: 'translate(0, 0)'
      },
      '50%': {
        transform: 'translate(18px, -18px)'
      },
      '75%': {
        transform: 'translate(0px, -36px)'
      },
      '100%': {
        transform: 'translate(-18px, -18px)'
      }
    },
    '@keyframes pathCircle': {
      '25%': {
        strokeDashoffset: '125'
      },
      '50%': {
        strokeDashoffset: '175'
      },
      '75%': {
        strokeDashoffset: '225'
      },
      '100%': {
        strokeDashoffset: '275'
      }
    },
    '@keyframes pathRect': {
      '25%': {
        strokeDashoffset: '64'
      },
      '50%': {
        strokeDashoffset: '128'
      },
      '75%': {
        strokeDashoffset: '192'
      },
      '100%': {
        strokeDashoffset: '256'
      }
    },
    '@keyframes pathTriangle': {
      '33%': {
        strokeDashoffset: '74'
      },
      '66%': {
        strokeDashoffset: '147'
      },
      '100%': {
        strokeDashoffset: '221'
      }
    },
    '@keyframes dotTriangle': {
      '33%': {
        transform: 'translate(0, 0)'
      },
      '66%': {
        transform: 'translate(10px, -18px)'
      },
      '100%': {
        transform: 'translate(-10px, -18px)'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
